import { useEffect, useState } from 'react';

// https://usehooks.com/useDebounce/
export function useDebounceValue<T>(value: T, delayMs: number = 500, dependencies?: any[]) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const finalDependencies = dependencies ? [...dependencies, delayMs] : [value, delayMs];
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delayMs);

    return () => {
      clearTimeout(handler);
    };
  }, finalDependencies);

  return debouncedValue;
}
